import React from 'react';

const ButtonPrimaryLarge = (props) => (
    <button className={`btn btn-primary btn-large`} {...props}>{props.children}</button>
);

export default ButtonPrimaryLarge;